import { create } from "zustand";
import { FlareApproveStoreProps } from "./interface/flare-approve-store.interface";
import {
  getInfoStepApprove,
  getOptionMonthSubmit,
  getOptionVocApprove,
  submitReportVoc,
  updateApproveStep,
} from "src/services/flare.service";
import { SubmitReportVocBody } from "src/entity/common/global.entity";
import { ApproveBody } from "src/entity/voc-approve/voc-approve.entity";
import { getInfoStepApproval, getOptionVocApproval } from "src/services/voc-approval";

export const flareApproveStore = create<FlareApproveStoreProps>((set) => ({
  loading: false,
  loadingSubmitVocReport: false,
  loadingGetApprove: false,
  approveData: null,
  selectedApprove: null,
  optionMonth: [],
  optionApprove: { year: [], month: [], approveNo: [] },
  error: null,
  getMonthCanApprove: async (year: string) => {
    set(() => ({ loading: true }));
    try {
      const res = await getOptionMonthSubmit(year);

      set(() => ({ loading: false, optionMonth: res.data?.data || [] }));
    } catch (err: any) {
      set(() => ({ loading: false, error: err?.message, optionMonth: [] }));
    }
  },
  createSubmitReportVoc: async (payload: SubmitReportVocBody) => {
    set(() => ({ loadingSubmitVocReport: true }));
    try {
      await submitReportVoc(payload);

      set(() => ({ loadingSubmitVocReport: false }));
    } catch (err: any) {
      set(() => ({ loadingSubmitVocReport: false, error: err?.message }));
      throw err;
    }
  },
  getInfoStepApprove: async (query: string) => {
    set(() => ({ loadingGetApprove: true }));
    try {
      const res = await getInfoStepApproval(query);

      set(() => ({ loadingGetApprove: false, approveData: res.data?.data || null, selectedApprove: res.data?.data?._id }));
    } catch (err: any) {
      set(() => ({ loadingGetApprove: false, error: err?.message, approveData: null, selectedApprove: null }));
    }
  },
  getOptionApprove: async (query: string) => {
    set(() => ({ loading: true }));
    try {
      const res = await getOptionVocApproval(query);

      set(() => ({ loading: false, optionApprove: res.data?.data }));
      return res.data?.data || [];
    } catch (err: any) {
      set(() => ({ loading: false, error: err?.message, optionApprove: { year: [], month: [], approveNo: [] } }));
    }
  },
  updateApproveStep: async (data: ApproveBody) => {
    set(() => ({ loading: true }));
    try {
      const res = await updateApproveStep(data);

      set(() => ({ loading: false }));
      return res.data?.data || [];
    } catch (err: any) {
      set(() => ({ loading: false, error: err?.message }));
      throw err;
    }
  },
}));
